var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAssign)?_c('v-btn',{attrs:{"small":"","text":""},on:{"click":function($event){return _vm.handleAssign()}}},[_vm._v("Assign")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }